/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";

const BookingPaidContainer = (props: {children: React.ReactNode | React.ReactNode[]}) => {
    return (
        <div className={"BookingPaid w-full flex flex-col justify-start items-center"}>
            <div className={"BookingPaidInner py-3 px-2 sm:py-12 px:12 flex flex-col space-y-4 sm:space-y-8  max-w-2xl"}>{props.children}</div>
        </div>
    );
};

export default BookingPaidContainer;
